import { getCookieDomain } from '@/utils/cookie'

export const useApolloToken = () => {
  const tokenCookie = useCookie('apollo-token', {
    path: '/',
    expires: new Date(Date.now() + 432000),
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const expiresCookie = useCookie('apollo-expires', {
    path: '/',
    expires: new Date(Date.now() + 432000),
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const userIdCookie = useCookie('ota-conv-context', {
    path: '/',
    maxAge: 60 * 60 * 24 * 5,
    domain: getCookieDomain()
  })

  const token = computed(() => tokenCookie?.value || '')
  const expires = computed(() => expiresCookie?.value || '')
  const userId = computed(() => userIdCookie?.value || '')

  const setToken = (value: string) => {
    tokenCookie.value = value
  }

  const setExpires = (value: string) => {
    expiresCookie.value = value
  }

  const setUserId = (value: string) => {
    userIdCookie.value = value
  }

  return {
    tokenCookie,
    token,
    setToken,
    expiresCookie,
    expires,
    setExpires,
    userIdCookie,
    userId,
    setUserId
  }
}
